<template>
    <div class="commercialinfo">
        <el-row>
            <el-col :span="24">
                <el-button style="padding: 0; margin: 20px;" type="text" icon="el-icon-back" @click="$router.go(-1)">
                    返回
                </el-button>
            </el-col>
        </el-row>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="课程标题" prop="title">
                <el-input v-model="ruleForm.title"></el-input>
            </el-form-item>
            <el-form-item label="课程封面" prop="cover_url" class="is-required">
                <el-col :span="10">
                    <activityCustomUpload :tip="'温馨提示：建议宽度为333*179px；大小限制在200K之内'" :formName="'cover_url'" :formValue="ruleForm.cover_url"
                                          @uploadSuccess="uploadSuccess">
                    </activityCustomUpload>
                </el-col>
            </el-form-item>
            <el-form-item label="课程排序">
                <el-input v-model="ruleForm.sort"></el-input>
            </el-form-item>
            <el-form-item label="解锁时间">
                <el-input v-model="ruleForm.unlock_duration" placeholder="输入数字即可，输入“1”即为1小时"></el-input>
            </el-form-item>
            <el-form-item label="课程链接" prop="media_source_url">
                <el-input v-model="ruleForm.media_source_url" @blur="getVideoDuration"></el-input> 填入oss地址
            </el-form-item>
            <el-form-item label="课程类型" prop="type">
                <el-radio-group v-model="ruleForm.type">
                    <el-radio :label="1">音频</el-radio>
                    <el-radio :label="2">视频</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="课程详情">
                <el-col :span="24">
                    <tinymce v-model="ruleForm.content" style="width: 90%"></tinymce>
                </el-col>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')" style="width: 100px;">确定</el-button>
                <el-button @click="resetForm('ruleForm')" style="width: 100px;">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import activityCustomUpload from "@/components/activityCustomUpload.vue";
import tinymce from "@/components/tinymce.vue";
import { coursecreateUpdate, courseinfo } from "@/api/commerciam";
export default {
    data() {
        return {
            ruleForm: {
                title: "",
                type: "",
                content: "",
                cover_url: "",
                sort: "",
                unlock_duration: "",
                media_source_url: "",
                duration: "",
                id: "",
                category_id: "",
            },
            rules: {
                title: [
                    {
                        required: true,
                        message: "请输入课程标题",
                        trigger: "blur",
                    },
                    {
                        min: 1,
                        max: 50,
                        message: "长度在 1 到 50 个字符",
                        trigger: "blur",
                    },
                ],
                type: [
                    {
                        required: true,
                        message: "请选择课程类型",
                        trigger: "change",
                    },
                ],
                cover_url: [
                    {
                        required: true,
                        message: "请上传课程封面",
                        trigger: "change",
                    },
                ],
                media_source_url: [
                    {
                        required: true,
                        message: "请输入课程链接",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    created() {
        this.ruleForm.id = this.$route.query.id;
        console.log(this.ruleForm.category_id, "this.ruleForm.category_id");
        if (this.ruleForm.id) {
            this.getcourseinfo();
        } else {
            this.ruleForm.category_id = this.$route.query.category_id;
        }
    },
    components: {
        activityCustomUpload,
        tinymce,
    },
    methods: {
        getcourseinfo() {
            // 获取单个课程数据
            courseinfo({ id: this.ruleForm.id }).then((res) => {
                if (res.code == 1) {
                    this.ruleForm = res.data;
                    this.ruleForm.category_id = this.$route.query.category_id;
                    this.getVideoDuration();
                }
            });
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // this.getVideoDuration()
                    console.log(this.ruleForm.sort);
                    if (this.ruleForm.sort.length > 0 && this.ruleForm.sort != "") {
                        // 检查值是否不为 null 和 undefined
                        let intnum = Number(this.ruleForm.sort);
                        if (Number.isInteger(intnum) && intnum > 0) {
                            // 如果是正整数，执行相关操作
                            coursecreateUpdate(this.ruleForm).then((res) => {
                                if (res.code == 1) {
                                    this.$message({
                                        message: "保存成功!",
                                        type: "success",
                                    });
                                    this.$router.go(-1);
                                }
                            });
                        } else {
                            // 如果不是正整数，可以选择执行其他操作或不执行任何操作
                            this.$message({
                                message: "排序请输入正整数!",
                                type: "error",
                            });
                            return;
                            // 提交编辑
                        }
                    } else {
                        console.log(this.ruleForm.cover_url);
                        if(this.ruleForm.cover_url == ''){
                            this.$message({
                                    message: "请上传课程封面!",
                                    type: "error",
                                });
                            return
                        }
                        coursecreateUpdate(this.ruleForm).then((res) => {
                            if (res.code == 1) {
                                this.$message({
                                    message: "保存成功!",
                                    type: "success",
                                });
                                this.$router.go(-1);
                            }
                        });
                    }
                } else {
                    this.$message({
                        message: "填写完成后才可保存!",
                        type: "error",
                    });
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$router.go(-1);
        },
        uploadSuccess(value) {
            const fileExtension = value.fileUrl.split(".").pop().toLowerCase();

            // 判断是否是图片格式
            const isImageFormat = ["png", "jpeg", "jpg", "gif", ""].includes(
                fileExtension
            );

            if (value.type != "delete") {
                console.log(
                    isImageFormat,
                    "isImageFormat",
                    fileExtension,
                    "fileExtension",
                    value.type,
                    "value",
                    value.file.file.size,
                    "value.size"
                );
                if (!isImageFormat) {
                    this.$message({
                        message: "请上传图片格式文件（png, jpeg, jpg, gif）",
                        type: "error",
                    });
                    console.log("1");
                    return;
                }

                // 创建一个图片对象来获取图片尺寸
                const img = new Image();
                img.onload = () => {
                    // 检查图片尺寸是否符合要求
                    if (img.width > 333 || img.height > 179) {
                        this.$message({
                            message: "图片尺寸不符，请重新上传",
                            type: "error",
                        });
                        console.log("2");
                        return;
                    }
                    const maxSizeInBytes = 200 * 1024; // 300KB
                    if (value.file.file.size > maxSizeInBytes) {
                        this.$message({
                            message: "图片大小不符，请重新上传",
                            type: "error",
                        });
                        console.log("3");
                        return;
                    }
                    console.log(img.src, " img.src = value.fileUrl;");
                    // 图片格式、尺寸、大小均符合要求，更新表单数据
                    this.ruleForm[value.formName] = this.rules[value.formName] =
                        value.fileUrl;
                    this.$refs.ruleForm.validateField(value.formName);
                };
                // 加载图片以获取其尺寸
                img.src = value.fileUrl;
            } else {
                if (isImageFormat) {
                    // console.log('是图片格式');
                    this.ruleForm[value.formName] = this.rules[value.formName] =
                        value.fileUrl;
                    this.$refs.ruleForm.validateField(value.formName);
                } else {
                    this.$message({
                        message: "请上传图片格式文件",
                        type: "error",
                    });
                    return;
                }
            }
        },
        getVideoDuration() {
            // 获取视频时长的函数
            // 创建一个 video 元素
            var video = document.createElement("video");
            // 设置 video 的 src 属性为输入框中的链接
            video.src = this.ruleForm.media_source_url;

            // 等待视频元数据加载完成后
            video.addEventListener("loadedmetadata", () => {
                // 获取视频的时长（秒）
                var duration = video.duration;
                console.log("视频时长（秒）：", duration);
                this.ruleForm.duration = duration + "";
                // 可以将时长格式化成更友好的时间格式，例如：hh:mm:ss
                // var formattedTime = this.formatTime(duration);
                // console.log("格式化后的时长：", formattedTime);
            });

            // 加载视频元数据
            video.load();
        },
        formatTime(seconds) {
            var hours = Math.floor(seconds / 3600);
            var minutes = Math.floor((seconds % 3600) / 60);
            var remainingSeconds = Math.floor(seconds % 60);

            var formatted = `${hours}:${minutes < 10 ? "0" : ""}${minutes}:${
                remainingSeconds < 10 ? "0" : ""
            }${remainingSeconds}`;
            return formatted;
        },
    },
};
</script>

<style>
.commercialinfo .el-input {
    width: 300px;
}
</style>
